// @flow
export const KEY = 'lib_users'
